import React, { useState, useEffect, useCallback, useMemo } from "react"
import { Button, Popover, Select } from 'antd';
import images from '../../themes/appImage'
import { useNavigate } from "react-router-dom";
import { Table, Modal } from 'antd';
import appconstant from "../../themes/appconstant";
import { useDispatch, useSelector } from "react-redux";
import { addEncouragementGroupLoad, encouragementGroupListLoad, encouragementScoreLoad, encouragmentScoreSuccess, engagementGroupDeleteLoad } from "../../redux/slices/encouragementgroups.slice";
import { debounce } from "../../utils/global-func";
import moment from "moment";
import { imageURL } from "../../redux/Api/apikit";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { emptySpaceInputHandler } from "../../utils";
import ModalPop from "../../common/modal";

const handleChange = () => {
};
const numberOfRowOptionList = [
    { value: 'one', label: 10 },
    { value: 'two', label: 20 },
    { value: 'three', label: 25 },
]
let LIST_LIMIT = 10
let OFFSET = 0
let currentSortValue = -1
let sort = "createdAt"
const userListPayload = {
    "offset": 0,
    "limit": 10,
    "search": "",
    "sort": sort,
    "order": currentSortValue
}

const EncouragementGroups = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [modal1Open, setModal1Open] = useState(false)
    const [search, setSearch] = useState("")
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const { encouragementGroupListData, addEncouragementGroupSuccess, storeData } = useSelector(state => state.EncouragementgroupsReducer);
    const Data = useSelector(state => state.EncouragementgroupsReducer);

    const handleDelete = () => {
        console.log("Delete id:", deleteId);

        // dispatch(engagementGroupDeleteLoad(deleteId))\
        dispatch(engagementGroupDeleteLoad({ groupId: deleteId }))

        setDeleteModal(false);
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'srno',
            key: 'srno',
            render: (value, item, index) => (OFFSET + index + 1)
        },
        {
            title: 'Title  ',
            dataIndex: 'title',
            key: 'title',
            sorter: false,
            sortDirections: ['ascend', 'descend'],
            title: () => {
                return (
                    <div onClick={() => sortHandler("name")} className="sort-icons cursor-pointer">
                        <span>Title</span> <img src={images.arrowLeft} alt="" />
                    </div>
                );
            },
            render: (value, item, index) => <div className="organization-image-sec">
                {item.icon && <span><img className="w-6 h-6 rounded-[100%] object-contain" src={`${imageURL}${item.icon}`} /></span>}
                {item.name}
            </div>
        },
        {
            title: 'Total Users',
            dataIndex: 'totalUser',
            key: 'totalUser',
        },
        {
            title: 'Date Created',
            dataIndex: 'createdAt',
            key: 'createdAt',
            sorter: false,
            sortDirections: ['ascend', 'descend'],
            title: () => {
                return (
                    <div onClick={() => sortHandler("createdAt")} className="sort-icons cursor-pointer">
                        <span>Date Created</span> <img src={images.arrowLeft} alt="" />
                    </div>
                );
            },
            render: (value, item, index) => <div className="organization-image-sec">
                {moment(item.createdAt).format('MMMM D, YYYY')}
            </div>
        },
        {
            title: 'Action',
            dataIndex: 'Posted',
            key: 'Posted',
            // align: 'center',
            render: (value, item, index) => {
                return (
                    <Popover
                        // content={
                        // <Button
                        //     type="text"
                        //     onClick={() => {
                        //         navigate('/gratitudeattitude', {
                        //             state: {
                        //                 groupId: item._id,
                        //                 groupName: item.name,
                        //                 description: item.description,
                        //                 image: item.image,
                        //                 icon: item.icon,
                        //             }
                        //         })
                        //     }}
                        // >
                        //     View
                        // </Button>
                        // }

                        content={
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <Button
                                    type="text"
                                    onClick={() => {
                                        navigate('/gratitudeattitude', {
                                            state: {
                                                groupId: item._id,
                                                groupName: item.name,
                                                description: item.description,
                                                image: item.image,
                                                icon: item.icon,
                                            }
                                        })
                                    }}
                                >
                                    View
                                </Button>

                                <Button
                                    type="text"
                                    danger
                                    onClick={() => {
                                        setDeleteId(item._id);
                                        setDeleteModal(true);
                                    }}
                                >
                                    Delete
                                </Button>
                            </div>
                        }
                        trigger="click"
                    >
                        <div className="relative action-dots-iocn">
                            <span>
                                <img src={images.horizontalDots} />
                            </span>
                        </div>
                    </Popover>

                )
            }
        },
    ];

    useEffect(() => {
        if (addEncouragementGroupSuccess) {
            setModal1Open(false)
            resetFormState()
        }
        dispatch(encouragementGroupListLoad(userListPayload))
        dispatch(encouragementScoreLoad());
    }, [addEncouragementGroupSuccess])

    // P A G I N A T I O N 

    // --S T A T E--
    const START = useMemo(() => OFFSET + 1, [encouragementGroupListData.groupList]);
    const TOTAL_LIST_ITEMS = useMemo(() => encouragementGroupListData.pagination?.totalCount, [encouragementGroupListData.groupList])
    const END = useMemo(() => (Math.min(OFFSET + LIST_LIMIT, TOTAL_LIST_ITEMS)), [encouragementGroupListData.groupList]);
    const canCallNextData = OFFSET + LIST_LIMIT < TOTAL_LIST_ITEMS

    // --A C T I O N S--

    const paginationHandler = useCallback((type) => {
        if (type === "pre") {
            OFFSET = OFFSET - LIST_LIMIT
            const data = {
                offset: OFFSET,
                limit: LIST_LIMIT,
                search: search,
                sort: sort,
                order: currentSortValue
            }
            dispatch(encouragementGroupListLoad(data));
        } else {
            OFFSET = OFFSET + LIST_LIMIT
            const data = {
                offset: OFFSET,
                limit: LIST_LIMIT,
                search: search,
                sort: "createdAt",
                order: -1
            }
            dispatch(encouragementGroupListLoad(data));
        }
    }, [encouragementGroupListData.groupList])

    const numberOfRowHandler = useCallback((ddateStringate, dataObj) => {
        LIST_LIMIT = dataObj.label
        OFFSET = 0
        const data = {
            offset: OFFSET,
            limit: LIST_LIMIT,
            search: search,
            sort: sort,
            order: currentSortValue
        }
        dispatch(encouragementGroupListLoad(data));
    }, [encouragementGroupListData.groupList])

    const searchHandler = useCallback((e) => {
        if (emptySpaceInputHandler(e) || e.target.value.length == "") {
            LIST_LIMIT = 10
            OFFSET = 0
            setSearch(emptySpaceInputHandler(e))
            const data = {
                offset: 0,
                limit: 10,
                search: emptySpaceInputHandler(e).trim(),
                order: -1
            }
            debounce(() => dispatch(encouragementGroupListLoad(data)))
        }
    }, [encouragementGroupListData.groupList]);

    const sortHandler = useCallback((sort) => {
        currentSortValue = currentSortValue == -1 ? 1 : -1
        const data = {
            offset: OFFSET,
            limit: LIST_LIMIT,
            search: search,
            sort: sort,
            order: currentSortValue
        }
        dispatch(encouragementGroupListLoad(data));
    }, [encouragementGroupListData.groupList])


    // F O R M I K  F O R  -- A D D  N E W  O R G A N I Z A T I O N  M O D AL 

    const validationSchema = Yup.object({
        name: Yup.string()
            .required('Please enter group name')
            .max(30, 'Group name must be at most 30 characters'),
        description: Yup.string()
            .required('Please enter group details')
            .min(10, 'Group details must be at least 10 characters')
            .max(500, 'Group details must be at most 500 characters'),
        image: Yup.string().required('Please upload cover image'),
        icon: Yup.string().required('Please upload icon'),
    });

    const formik = useFormik({
        initialValues: {
            name: '',
            description: '',
            image: '',
            icon: '',
        },
        validationSchema,
        onSubmit: (values, { resetForm }) => {
            const form = new FormData()
            form.append("name", values.name)
            form.append("description", values.description)
            form.append("image", values.image)
            form.append("icon", values.icon)
            dispatch(addEncouragementGroupLoad(form))
        },
    });

    const inputHandler = (event) => {
        let { name } = event.target;
        formik.setFieldValue(name, emptySpaceInputHandler(event));
    };


    const resetFormState = () => {
        formik.setValues({
            name: "",
            description: "",
            image: "",
            icon: ""
        });
        formik.setTouched({
            name: null,
            description: null,
            image: null,
            icon: null
        });
    }
    return (
        <div>
            <div className="site-layout-background" style={{ minHeight: 360 }}>
                <div className="top-header-organi-zations">
                    <div className="organi-zations-heading-text">
                        <h1>Encouragement Groups</h1>
                        {/* <p>Sed consectetur imperdiet facilisiulla malesua daeddiet facilisiulla</p> */}
                    </div>
                    <div className="add-new-button user-page-btn">
                        <button onClick={() => setModal1Open(true)} >Add Encouragement Group</button>
                    </div>
                </div>

                <div className="total-user ">
                    <div className="user-count number-inner-cricle-ps">
                        <p>Number of Encouragement Groups</p>
                        <h1>{storeData[0]?.group}</h1>
                    </div>

                    <div className="user-count number-inner-cricle-ps">
                        <p>Number of Subscribed User</p>
                        <h1>{storeData[0]?.groupMember}</h1>
                    </div>

                    <div className="user-count number-inner-cricle-ps">
                        <p>Number of Posts</p>
                        <h1>{storeData[0]?.totalPost}</h1>
                    </div>

                </div>

                <div className="content-e">
                    <div class="bg-gradient-primary  system-line">
                        <input type="text" value={search} onChange={searchHandler} className="iocn-search  search-bar" placeholder="Search encouragement groups" />
                        {/* Version 2 */}
                        {/* <div className="top-checkbox">
                            <Select
                                defaultValue="Filter"
                                onChange={handleChange}
                                options={[
                                    { value: 'one', label: '1 months' },
                                    { value: 'two', label: '3 months' },
                                    { value: 'three', label: '6 months' },

                                ]}
                            />
                        </div> */}
                    </div>

                    <Table
                        dataSource={encouragementGroupListData.groupList}
                        columns={columns}
                        showSorterTooltip={false}
                        pagination={{
                            current: 0,
                            pageSize: 0,
                            total: TOTAL_LIST_ITEMS,
                        }}
                    />

                    {TOTAL_LIST_ITEMS > 10 && <div className="footer-section">
                        <div className="foot-main-div">
                            <div className="rows">
                                <div className="row-per-page">
                                    <p>Rows per page</p>
                                </div>
                                <div className="top-checkbox fot-select">
                                    <Select
                                        defaultValue={LIST_LIMIT}
                                        onChange={numberOfRowHandler}
                                        options={numberOfRowOptionList}
                                    />
                                </div>
                            </div>

                            <div className="page-count">
                                <p>{`${START}-${END} of ${TOTAL_LIST_ITEMS}`}</p>
                            </div>

                            <div className="back-and-next">
                                {/* <span><img src={images.back} alt="back" /></span> */}
                                <span onClick={() => OFFSET !== 0 && paginationHandler("pre")}><img src={OFFSET == 0 ? images.per : images.paginationDimLeft} style={{ tintColor: "red" }} alt="back" /></span>
                                <span onClick={() => canCallNextData && paginationHandler("next")}><img src={canCallNextData == false ? images.paginationDimRight : images.new} alt="back" /></span>
                                {/* <span><img src={images.next} alt="back" /></span> */}
                            </div>

                        </div>

                    </div>}
                </div>
            </div>

            <Modal
                title=""
                className="modal-update"
                centered
                visible={modal1Open}
                closable={true}
                onCancel={() => {
                    resetFormState()
                    setModal1Open(false)
                }}
                footer={false}
                width={600}  >
                <div className="add-user-popup">

                    <div className="modal-add-user">
                        <h1>Add Encouragement Group </h1>
                    </div>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="description-inner-circle " >
                            <div className="wrapper_line">
                                <div className="form-group">
                                    <label>{appconstant.enGroupTitle}</label>
                                    <input
                                        className='form-control'
                                        type='text'
                                        placeholder='Enter Encouragement Group'
                                        name='name'
                                        value={formik.values.name}
                                        onChange={inputHandler}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.name && formik.errors.name ? (
                                        <div className="text-red-500 text-xs mt-1 font-normal">{formik.errors.name}</div>
                                    ) : null}
                                </div>

                                <div className="form-group">
                                    <div className="textarea-label">
                                        <label>{appconstant.enGroupDetail}</label>
                                        <p>{formik.values.description.length}/500</p>
                                    </div>
                                    <textarea
                                        rows="5"
                                        cols="50"
                                        className='form-control-textarea'
                                        type='textarea'
                                        placeholder='Enter details here'
                                        name='description'
                                        value={formik.values.description}
                                        onChange={(e) => {
                                            const getStringLength = e.target.value.length
                                            if (getStringLength <= 500) {
                                                inputHandler(e)
                                            }
                                        }}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.description && formik.errors.description ? (
                                        <div className="text-red-500 text-xs mt-1 font-normal">{formik.errors.description}</div>
                                    ) : null}
                                </div>
                            </div>
                        </div>

                        <div className="add-sugg-activity"
                            style={{ marginTop: "59px" }}
                        >
                            <div className="click-to-upload label-top-space">
                                <label >Upload Cover</label>
                                {formik.values.image ?
                                    <div className="w-[30%]  relative">
                                        <div onClick={() => formik.setFieldValue("image", "")} className="bg-white w-4 h-4 cursor-pointer absolute -right-3 -top-2 border border-black rounded-full flex justify-center items-center">
                                            <img className="w-[60%] h-[60%] rounded-full object-contain" src={images.crossIcon} />
                                        </div>
                                        <img className="h-20 w-full mt-2 object-contain mb-5" src={URL.createObjectURL(formik.values.image)} alt="upload" />
                                    </div>
                                    : <>
                                        <label className="cursor-pointer" htmlFor="uploadCoverPic">
                                            <div className="upload-file new-up-file label-less-margin">
                                                <div className="upload-center-text add-up-activity">
                                                    <p ><span><img src={images.upload} alt="upload" /></span>Click here to upload</p>
                                                </div>
                                                <p className="image-disp">File Format: .JPEG, .PNG .SVG</p>
                                            </div>
                                        </label>
                                        {formik.touched.image && formik.errors.image ? (
                                            <div className="text-red-500 text-xs mt-1 font-normal">{formik.errors.image}</div>
                                        ) : null}
                                        <input
                                            type="file"
                                            accept="image/*,image/svg+xml"
                                            id="uploadCoverPic"
                                            style={{ display: "none" }}
                                            onChange={(e) => formik.setFieldValue("image", e.target.files[0])}
                                        // onChange={(e) => uploadFileHandler("uploadCoverPic", e)}
                                        />
                                    </>}
                            </div>

                            <div className="upload-icons-text">
                                <label>Upload Icon</label>

                                {formik.values.icon ?
                                    <div className="w-[30%]  relative">
                                        <div onClick={() => formik.setFieldValue("icon", "")} className="bg-white w-4 h-4 cursor-pointer absolute -right-3 -top-2 border border-black rounded-full flex justify-center items-center">
                                            <img className="w-[60%] h-[60%] rounded-full object-contain" src={images.crossIcon} />
                                        </div>
                                        <img className="h-20 w-full object-contain mt-2 mb-5" src={URL.createObjectURL(formik.values.icon)} alt="upload" />
                                    </div>
                                    :
                                    <label className="cursor-pointer" htmlFor="uploadLogo">
                                        <div className="click-here-to-up">
                                            <p>Click here to upload icon</p>
                                            <img src={images.upload} alt="upload" />
                                        </div>
                                        {formik.touched.icon && formik.errors.icon ? (
                                            <div className="text-red-500 text-xs mt-1 font-normal">{formik.errors.icon}</div>
                                        ) : null}
                                        <input
                                            type="file"
                                            accept="image/*,image/svg+xml"
                                            id="uploadLogo"
                                            style={{ display: "none" }}
                                            onChange={(e) => formik.setFieldValue("icon", e.target.files[0])}
                                        />
                                    </label>}
                            </div>
                        </div>

                        <div className="click-to-upload">
                            <div className="add-activity-button add-space-group">
                                <button type="submit" >Add Encouragement Group</button>
                            </div>
                        </div>
                    </form>

                </div>
            </Modal>

            <ModalPop
                title="Delete Encouragement Group"
                content="Are you sure you want to delete this Encouragement Group?"
                isVisible={deleteModal}
                handleSuccess={handleDelete}
                handleCancel={() => setDeleteModal(false)}
                btnSuccess={
                    <Button type="primary" className="text-black" onClick={handleDelete}>
                        Delete
                    </Button>
                }
            />
        </div>
    )
}
export default EncouragementGroups

